import React from 'react';
import PropTypes from 'prop-types';
import useUserRole from '../../Hooks/use-UserRole'
const TopLink = ({ href, title, text, notification = undefined }) => {
  // history is not used after migration
  if (typeof href !== 'string' || !href.startsWith('/')) {
    console.error('Invalid href provided:', href);
    return;
  }

  const sanitizedHref = encodeURI(href);
  const handleNotificationClick = (e) => {
    e.preventDefault();

    if (
      (sessionStorage.getItem('loggedUser') !== '' &&
      sessionStorage.getItem('loggedUser') !== null && 
      sessionStorage.getItem('assignedUser') !== '' &&
      sessionStorage.getItem('assignedUser') !== null && 
      sessionStorage.getItem('assignedUser') == sessionStorage.getItem('loggedUser'))
      &&
      (!sessionStorage.getItem('remote_user'))){
        if(sanitizedHref === '/Notifications'){
          window.location.href = '/Notifications';
        }
        if(sanitizedHref === '/MyProfile'){
          window.location.href = '/MyProfile';
        }
    }
    else
    {
    if (confirm("Are you sure you want to navigate to Notification page? This will reset view to your profile if you were impersonating any user/viewing another user's profile.") == true) {
      sessionStorage.setItem('assignedUser',sessionStorage.getItem('loggedUser'));
      sessionStorage.removeItem('remote_user');
      if(sanitizedHref === '/Notifications'){
        window.location.href = '/Notifications';
      }
      if(sanitizedHref === '/MyProfile'){
        window.location.href = '/MyProfile';
      } 
     
    } 
  }
  };
  const tempUserRole = useUserRole();

  const getCurrentPath = window.location.pathname;
  const currentPath =
    getCurrentPath === '/Notifications' && text === 'Notifications'
      ? 'notification-strong'
      : '';

  let notificationicon;
  if (notification > 0) {
    notificationicon = <span className="notification">{notification}</span>;
  } else {
    notificationicon = '';
  }

  return (
    <>{(tempUserRole === 'employee') ?
      (
        <a href="#" className='no-decor' onClick={handleNotificationClick} title={title} tabIndex="0">
          <span className={currentPath}>{text}</span>
          {notificationicon}
        </a>
      )
      :
      (
        <a href={href} className='no-decor' title={title} tabIndex="0">
          <span className={currentPath}>{text}</span>
          {notificationicon}
        </a>
      )}



    </>
  );
};

TopLink.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  notification: PropTypes.string,
};



export default TopLink;
